import $ from 'jquery';
import { subscribe, unsubscribe } from "../01-helpers/event-manager";
import { COVEO_INITIALIZED } from "../02-const/event-names";

const selectors = {
    coveoInitOptions: '#coveo-init-options',
    loadmoreButton: '.js-search__loadmore',
    template: 'script.result-template',
    resultlist: '.CoveoResultList',
    resultlistContainer: '.CoveoResultList .coveo-result-list-container',
    search: '#search'
};

var items = 0;

function coveoInitialized() {
    // Remove items fetched using 'load more' when a different facet is selected (as this is not done by default by Coveo :|)
    Coveo.$(this.el).on('state:change:f:' + $(this.el).find('.CoveoFacet:first').attr('id'), this.onFacetChange);

}

class ImproveGolfSearch {
    constructor(el) {
        this.el = el;

        this.init();
    }

    /**
     * Load more results and show them on the page
     * @param {any} ev
     */
    onLoadMore(ev) {
		ev.preventDefault();
		_.templateSettings = {
			evaluate: /{{([\s\S]+?)}}/g,
			interpolate: /{{=([\s\S]+?)}}/g,
			escape: /{{-([\s\S]+?)}}/g
		};

        var qc = Coveo.$(selectors.resultlist).coveo().queryController;

        qc.fetchMore(items).done(function (data) {
            var template = _.template('<div class="CoveoResult js-more">' + Coveo.$(selectors.search).find(selectors.template).html() + '</div>');

            for (var i = 0; i < data.results.length; i++) {
                var extended = _.extend({}, data.results[i], Coveo.TemplateHelpers.helpers);
                Coveo.$(selectors.search).find(selectors.resultlistContainer).append(template(extended));
            }
        });
    }

    onFacetChange(ev) {
        Coveo.$(selectors.search).find(selectors.resultlist).find('.js-more').remove();
    }

	/**
	 * Initialize the module 
	 **/
    init() {
        items = $(this.el).data('results-per-page');

        // Enable the 'load more'-button
        $(this.el).find(selectors.loadmoreButton).on('click', this.onLoadMore);

        subscribe(COVEO_INITIALIZED, coveoInitialized.bind(this));
    }

    destroy() {
        unsubscribe(COVEO_INITIALIZED, dropdownClicked.bind(this));
    }
}

export {
    ImproveGolfSearch as ImproveGolfSearch
};